export default __webpack_public_path__ + "static/media/walkthrough-2.67aa57fc.png";